import { Injectable } from '@angular/core';
import { FileDto } from '../../models/models';
import FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  downloadFromBytes(fileDto: FileDto) {
    const byteCharacters = atob(fileDto.fileBytes);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const file = new Blob([byteArray], { type: fileDto.fileType });
    FileSaver.saveAs(file, fileDto.fileName);
  }
}
